import AlbumFolderSubscriptionOption from './AlbumFolderSubscriptionOption';

export default AlbumFolderSubscriptionOption;
